import { useMemo } from 'react';
import { Provider } from 'react-redux';
import { MemoryRouter, Route, Routes } from 'react-router-dom';
import { createFeatureBundleStore } from '@triedge/rtk-abstractions';
import { createMockStaffSettingsFeatureBundle } from '../feature-bundle/index';
import { createSettingsRoutes } from '../routes/index';
import type { SettingsFeatureBundle, StaffSettingsFeatureBundlePreviewProps } from '../types';

export const storybookSettingsBundle = createMockStaffSettingsFeatureBundle('/school/settings');

export const StaffSettingsFeatureBundlePreview = ({
  bundle,
  initialEntry = '/school/settings/general',
  operatorPersona = 'admin',
}: StaffSettingsFeatureBundlePreviewProps) => {
  const resolvedBundle: SettingsFeatureBundle = useMemo(
    () => bundle ?? createMockStaffSettingsFeatureBundle('/school/settings', { operatorPersona }),
    [bundle, operatorPersona],
  );

  const store = useMemo(
    () =>
      createFeatureBundleStore({
        bundles: [resolvedBundle],
      }),
    [resolvedBundle],
  );

  return (
    <Provider store={store}>
      <MemoryRouter initialEntries={[initialEntry]}>
        <Routes>
          <Route path="/school/settings">
            {createSettingsRoutes(resolvedBundle)}
          </Route>
          <Route path="/settings">
            {createSettingsRoutes(resolvedBundle)}
          </Route>
        </Routes>
      </MemoryRouter>
    </Provider>
  );
};
